import camelCase from 'camel-case';

export default function formatName (str) {
  return camelCase(str.replace(/[^a-zA-Z0-9]/g, ' '));
}



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/formatName.js